import { getCookieChild, getElement, getElements } from "./utils";

export const couponByState = () => {
  const coupons = getElements('.bassets-coupons__wrapper .bassets-coupons__item');
  const couponsWrapper = getElement('.bassets-coupons__wrapper');
  const errorIfNoCoupons = getElement('.bassets-category-coupons__error');
  const currentCity = getCookieChild('selectedCity');

  if (!currentCity) {
    errorIfNoCoupons?.classList.remove('hidden');
    return;
  }

  if (!coupons?.length) return;

  couponsWrapper?.classList.remove('loading');

  coupons.forEach((coupon) => {
    const categories = coupon.getAttribute('data-categories')?.split(',') || [];
    if (categories.includes(currentCity)) {
      coupon.classList.remove('hidden');
    }
  });
};